import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import { cloneDeep } from 'lodash';
import { loadCSS } from 'fg-loadcss';

import { v4 as uuidv4 } from 'uuid';

import '../../../common/ItemsList.css'

import {
    HomePageMenuItem,
    WebViewMenuItem,
    BusinessCardMenuItem,
    EmailMenuItem,
    EmptyLineMenuItem,
    OpenUrlMenuItem,
    PhoneCallMenuItem,
    PhotoEditorMenuItem,
    PhotoSendMenuItem,
    QrMenuItem,
    SeparatorMenuItem,
    SmsMessageMenuItem
} from './MenuItems';

import {
    Badge,
    Button,
    Card,
    CardContent,
    Grid,
    Menu,
    MenuItem,
    Typography
} from '@material-ui/core';

import {
    FieldError
} from '../../../common';

import { MenuItemDefaultValue, MenuItemTypes } from '../../../../helpers';

import { PageContext } from '../PageContext';

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { useTranslation } from "react-i18next";

import AddIcon from '@material-ui/icons/Add';
import WarningIcon from '@material-ui/icons/Warning';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';

import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        padding: 0
    },
    title: {
        fontSize: "1.2em"
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    },
    progress: {
        color: "black"
    },
    pickerBox: {
        marginLeft: -6
    },
    menu: {
    },
    itemsList: {
        height: 400
    },
    bigIcon: {
        width: 100,
        height: 100
    }
}));

export const MenuForm = ({
    formRef,
    errors,
    disabled,
    upload,
    onSubmit,
    ...props }) => {
    const classes = useStyles();
    const theme = useTheme();

    const { t, i18n } = useTranslation();

    const {
        state,
        mergeMenuItems
    } = useContext(PageContext);

    const {
        icons,
        settings,
        menuItems: sourceItems
    } = state;

    const [menuItems, setMenuItems] = useState(sourceItems ?? []);

    const getListStyle = isDraggingOver => ({
        background: '#CCCCCC',
        padding: '16px 8px 0px 16px',
        width: 'calc(100% - 32px)',
        height: 1000,
        overflowY: "scroll",
        borderRadius: 4,
        boxShadow: ' inset 0px 0px 5px 0px rgb(0,0,0,0.3)',
    });

    const getItemStyle = (isDragging, draggableStyle, isSelected) => ({
        margin: "0px 0px 16px 0px",
        zIndex: 100,
        padding: 8,
        color: isSelected ? '#fff' : '#000',
        width: 'calc(100% - 28px)',
        height: 72,

        background: '#fff',
        boxShadow: '0 2px 3px rgb(10 10 10 / 10%), 0 0 0 2px rgb(10 10 10 / 10%)',
        backgroundColor: isSelected ? theme.palette.primary.main : '#fff',
        borderRadius: 10,

        ...draggableStyle
    });

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        replaceMenuItems(
            reorder(
                [...menuItems],
                result.source.index,
                result.destination.index
            )
        );
    }

    const [currentItemId, setCurrentItemId] = useState((menuItems ?? []).length > 0 ? menuItems[0].id : null);

    const [anchorEl, setAnchorEl] = useState(null);

    const getMenuItemKeys = () => {
        return Object
            .keys(MenuItemTypes.Label)
            .sort((x, y) => {
                const k1 = MenuItemTypes.Label[x].toUpperCase();
                const k2 = MenuItemTypes.Label[y].toUpperCase();
                if (k1 < k2) {
                    return -1;
                } else if (k1 > k2) {
                    return 1;
                } else {
                    return 0;
                }
            });
    }

    const addMenuItem = (item) => {
        item.id = uuidv4();
        const newMenuItems = cloneDeep(menuItems ?? []);
        newMenuItems.push(item);
        setMenuItems(newMenuItems);
        mergeMenuItems(newMenuItems);
        return item.id;
    }

    const updateMenuItem = (id, values) => {
        let newMenuItems = cloneDeep(menuItems ?? []);
        let index = newMenuItems.findIndex(x => x.id === id);
        newMenuItems[index] = { ...newMenuItems[index], ...values };
        setMenuItems(newMenuItems);
        mergeMenuItems(newMenuItems);
    }

    const removeMenuItem = (id) => {
        let newMenuItems = cloneDeep(state.menuItems ?? []);
        setMenuItems(newMenuItems.filter(item => item.id !== id));
        mergeMenuItems(newMenuItems.filter(item => item.id !== id));
    }

    const replaceMenuItems = (newMenuItems) => {
        setMenuItems(newMenuItems);
        mergeMenuItems(newMenuItems);
    }

    const getCurrentMenuItemEditor = (menuItems, currentItemId) => {
        let menuItemComponent = null;
        const currentItem = currentItemId ? menuItems.find(item => item.id === currentItemId) : null;
        switch (currentItem?.type) {
            case MenuItemTypes.HomePage:
                menuItemComponent =
                    <HomePageMenuItem
                        item={currentItem}
                        errors={errors}
                        icons={icons}
                        //validationSchema={MenuItemValidateSchema.HomePage}
                        formRef={formRef}
                        disabled={disabled}
                        upload={upload}
                        onUpdated={updateItemHandler}
                        onRemove={removeMenuItemHandler}
                        onSubmit={submitHandler}
                    />
                break;
            case MenuItemTypes.BusinessCard:
                menuItemComponent =
                    <BusinessCardMenuItem
                        item={currentItem}
                        errors={errors}
                        icons={icons}
                        //validationSchema={MenuItemValidateSchema.BusinessCard}
                        formRef={formRef}
                        disabled={disabled}
                        upload={upload}
                        onUpdated={updateItemHandler}
                        onRemove={removeMenuItemHandler}
                        onSubmit={submitHandler}
                    />
                break;
            case MenuItemTypes.MailTo:
                menuItemComponent =
                    <EmailMenuItem
                        item={currentItem}
                        errors={errors}
                        icons={icons}
                        //validationSchema={MenuItemValidateSchema.MailTo}
                        formRef={formRef}
                        disabled={disabled}
                        upload={upload}
                        onUpdated={updateItemHandler}
                        onRemove={removeMenuItemHandler}
                        onSubmit={submitHandler}
                    />
                break;
            case MenuItemTypes.EmptyLine:
                menuItemComponent =
                    <EmptyLineMenuItem
                        item={currentItem}
                        errors={errors}
                        icons={icons}
                        //validationSchema={MenuItemValidateSchema.EmptyLine}
                        formRef={formRef}
                        disabled={disabled}
                        upload={upload}
                        onUpdated={updateItemHandler}
                        onRemove={removeMenuItemHandler}
                        onSubmit={submitHandler}
                    />
                break;
            case MenuItemTypes.OpenURL:
                menuItemComponent =
                    <OpenUrlMenuItem
                        item={currentItem}
                        errors={errors}
                        icons={icons}
                        //validationSchema={MenuItemValidateSchema.OpenURL}
                        formRef={formRef}
                        disabled={disabled}
                        upload={upload}
                        onUpdated={updateItemHandler}
                        onRemove={removeMenuItemHandler}
                        onSubmit={submitHandler}
                    />
                break;
            case MenuItemTypes.PhoneCall:
                menuItemComponent =
                    <PhoneCallMenuItem
                        item={currentItem}
                        errors={errors}
                        icons={icons}
                        //validationSchema={MenuItemValidateSchema.PhoneCall}
                        formRef={formRef}
                        disabled={disabled}
                        upload={upload}
                        onUpdated={updateItemHandler}
                        onRemove={removeMenuItemHandler}
                        onSubmit={submitHandler}
                    />
                break;
            case MenuItemTypes.PhotoEditor:
                menuItemComponent =
                    <PhotoEditorMenuItem
                        item={currentItem}
                        errors={errors}
                        icons={icons}
                        //validationSchema={MenuItemValidateSchema.PhotoEditor}
                        formRef={formRef}
                        disabled={disabled}
                        upload={upload}
                        onUpdated={updateItemHandler}
                        onRemove={removeMenuItemHandler}
                        onSubmit={submitHandler}
                    />
                break;
            case MenuItemTypes.PhotoSend:
                menuItemComponent =
                    <PhotoSendMenuItem
                        item={currentItem}
                        errors={errors}
                        icons={icons}
                        //validationSchema={MenuItemValidateSchema.PhotoSend}
                        formRef={formRef}
                        disabled={disabled}
                        upload={upload}
                        onUpdated={updateItemHandler}
                        onRemove={removeMenuItemHandler}
                        onSubmit={submitHandler}
                    />
                break;
            case MenuItemTypes.QR:
                menuItemComponent =
                    <QrMenuItem
                        item={currentItem}
                        errors={errors}
                        icons={icons}
                        //validationSchema={MenuItemValidateSchema.QR}
                        formRef={formRef}
                        disabled={disabled}
                        upload={upload}
                        onUpdated={updateItemHandler}
                        onRemove={removeMenuItemHandler}
                        onSubmit={submitHandler}
                    />
                break;
            case MenuItemTypes.Separator:
                menuItemComponent =
                    <SeparatorMenuItem
                        item={currentItem}
                        errors={errors}
                        icons={icons}
                        //validationSchema={MenuItemValidateSchema.Separator}
                        formRef={formRef}
                        disabled={disabled}
                        upload={upload}
                        onUpdated={updateItemHandler}
                        onRemove={removeMenuItemHandler}
                        onSubmit={submitHandler}
                    />
                break;
            case MenuItemTypes.SendSms:
                menuItemComponent =
                    <SmsMessageMenuItem
                        item={currentItem}
                        errors={errors}
                        icons={icons}
                        //validationSchema={MenuItemValidateSchema.SendSms}
                        formRef={formRef}
                        disabled={disabled}
                        upload={upload}
                        onUpdated={updateItemHandler}
                        onRemove={removeMenuItemHandler}
                        onSubmit={submitHandler}
                    />
                break;
            case MenuItemTypes.OnLineWebView:
                menuItemComponent =
                    <WebViewMenuItem
                        item={currentItem}
                        errors={errors}
                        icons={icons}
                        //validationSchema={MenuItemValidateSchema.OnLineWebView}
                        formRef={formRef}
                        disabled={disabled}
                        upload={upload}
                        onUpdated={updateItemHandler}
                        onRemove={removeMenuItemHandler}
                        onSubmit={submitHandler}
                    />
                break;
            default:
                menuItemComponent = <div style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    opacity: 0.7
                }}>
                    <EmojiObjectsIcon className={classes.bigIcon} />
                    <Typography variant="h5">
                        {t("LabelNoMenuItems")}
                    </Typography>
                </div>
        }

        return menuItemComponent;
    }

    const addMenuItemHandler = (menuItemType) => {
        const newMenuItem = {
            ...cloneDeep(MenuItemDefaultValue[menuItemType]),
            textColor: settings.menuItemsTextColor,
            backgroundColor: settings.menuItemsBackgroundColor
        }
        const menuItemId = addMenuItem(newMenuItem);
        setCurrentItemId(menuItemId);
    }

    const updateItemHandler = (menuItem, values) => {
        updateMenuItem(menuItem.id, values);
    }

    const removeMenuItemHandler = (menuItem) => {
        removeMenuItem(menuItem.id);
    }

    const submitHandler = (itemId, values, done) => {
        if (onSubmit) {
            onSubmit(cloneDeep(menuItems), done)
        }
    }

    useEffect(() => {
        if (menuItems) {
            if (!menuItems.find(item => item.id === currentItemId)) {
                setCurrentItemId(menuItems.length > 0 ? menuItems[0].id : null)
            } else {
                setCurrentItemId(currentItemId);
            }
        }
    }, [menuItems]);

    useEffect(() => {
        const node = loadCSS(
            'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
            document.querySelector('#font-awesome-css'),
        );

        return () => {
            node.parentNode.removeChild(node);
        };
    }, []);

    return (
        <Card className={clsx(classes.root, props.className)} style={{ padding: 0 }}>
            <CardContent style={{ padding: 0 }}>
                <Grid
                    container
                    direction='row'
                    style={{ padding: 0 }}>
                    <Grid item xs={12} lg={6} xl={4} style={{ backgroundColor: '#fff', padding: '0px 0px 30px 20px' }} >
                        <div style={{ height: 60, zIndex: 10, display: 'flex', alignItems: 'center', flexDirection: 'row-reverse', padding: '0px 8px 0px 0px' }}>
                            <Button
                                variant="contained"
                                disabled={disabled}
                                startIcon={<AddIcon />}
                                onClick={(e) => setAnchorEl(e.currentTarget)}>
                                {t("ButtonAddMenuItem")}
                            </Button>
                            <div style={{ marginRight: 16 }}>
                                <FieldError
                                    name="missingHomePage"
                                    errors={errors}
                                />
                            </div>
                            <Menu
                                anchorEl={anchorEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={(e) => setAnchorEl(null)}
                                className={classes.menu}>
                                {getMenuItemKeys().map(key =>
                                    <MenuItem
                                        key={MenuItemTypes.Label[key]}
                                        onClick={(e) => addMenuItemHandler(key)}>
                                        {MenuItemTypes.Label[key]}
                                    </MenuItem>)}
                            </Menu>
                        </div>
                        <DragDropContext onDragEnd={onDragEnd} >
                            <Droppable isDropDisabled={disabled} droppableId="droppable">
                                {(provided, snapshot) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                        className={clsx(classes.itemsList, "mnu-itms-list")}>
                                        {menuItems && menuItems.map((item, index) => (
                                            <Draggable key={item.id} isDragDisabled={disabled} draggableId={item.id} index={index}>
                                                {(provided, snapshot) => (
                                                    <Badge
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style,
                                                            item.id === currentItemId
                                                        )}
                                                        anchorOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'right',
                                                        }}
                                                        badgeContent={<WarningIcon color="secondary" />}
                                                        invisible={errors.find(err => err.errorId.includes(`${item.id}`)) ? false : true}
                                                        onClick={() => {
                                                            setCurrentItemId(item.id)
                                                        }}
                                                    >
                                                        <Grid
                                                            container
                                                            direction='row'
                                                            alignItems='center'
                                                            style={{
                                                                backgroundImage: `url(${item.backgroundImage})`,
                                                            }}>
                                                            <Grid item xl={2} lg={2} md={2} sm={3} xs={3} style={{ padding: 16, fontSize: 36 }}>
                                                                <i className={item.icon} />
                                                            </Grid>
                                                            <Grid item xl={10} lg={10} md={10} sm={9} xs={9} >
                                                                <Grid container direction='row'>
                                                                    <Grid item xs={12}>
                                                                        <Typography variant="caption">{item.type}</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Typography variant="h6">{item.title}</Typography>
                                                                    </Grid>
                                                                    {(item.type === MenuItemTypes.HomePage || item.type === MenuItemTypes.OpenURL || item.type === MenuItemTypes.OnLineWebView) &&
                                                                        <Grid item xs={12}>
                                                                            <Typography variant="caption">{item.props.url}</Typography>
                                                                        </Grid>
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Badge>

                                                )}

                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Grid>
                    <Grid item xs={12} lg={6} xl={8} style={{ padding: 20 }}>
                        {getCurrentMenuItemEditor(menuItems, currentItemId)}
                    </Grid>
                </Grid>
            </CardContent>
        </Card >
    );
}